import React from 'react'
import { Helmet } from 'react-helmet'
import delve from 'dlv'

export default function Metadata({
  pageTitle,
  ogTitle = `Kinzoo | ${pageTitle}`,
  twitterTitle = ogTitle,
  description,
  ogDescription = description,
  twitterDescription = ogDescription,
  ogImage,
  twitterImage = ogImage,
}) {
  const imgmod = `?w=3000&h=1570&fit=fill&f=faces&fm=jpg&q=82`
  return (
    <Helmet>
      <title>Kinzoo | {pageTitle}</title>
      <meta property="og:title" content={ogTitle} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="description" property="og:description" content={description} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="image" property="og:image" content={'https:' + delve(ogImage, 'file.url', '') + imgmod} />
      <meta name="twitter:image" content={'https:' + delve(twitterImage, 'file.url', '') + imgmod} />
      <meta name="referrer" content="origin" />
    </Helmet>
  )
}
